import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import brandLogo from '../../assets/feedaia-logo.svg';
import brandIcon from '../../assets/logo-icon.svg';

/**
 * AgentCy Labs brand lockup — uses the existing product logo assets.
 */
export default function BrandLockup({
  to = '/dashboard',
  collapsed = false,
  className,
  asLink = true,
  width = 148,
}) {
  const content = collapsed ? (
    <img src={brandIcon} alt="AgentCy Labs" width={28} height={28} className="flex-shrink-0" />
  ) : (
    <img src={brandLogo} alt="AgentCy Labs" width={width} className="max-w-full h-auto" />
  );

  if (!asLink) {
    return <span className={cn('inline-flex items-center', className)}>{content}</span>;
  }

  return (
    <Link to={to} className={cn('inline-flex items-center no-underline', className)} aria-label="AgentCy Labs">
      {content}
    </Link>
  );
}
